import { Box } from '@mui/material';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@/components/accordion';

interface MultiAccordionsItemProps {
  isMulti?: boolean;
  isSelected?: boolean;
  onSelect?: () => void;
  defaultExpanded?: boolean;
  Summary: React.ReactNode;
  Details: React.ReactNode;
}

export const MultiAccordionsItem = (props: MultiAccordionsItemProps) => {
  const { isSelected, isMulti, onSelect, Summary, Details, defaultExpanded } =
    props;
  return isMulti ? (
    <Accordion
      sx={{
        paddingY: '12px',
        paddingLeft: '40px',
      }}
      expanded={isSelected}
      defaultExpanded={defaultExpanded}
    >
      <AccordionSummary
        sx={{
          '& .MuiTypography-root': { fontWeight: '400 !important' },
        }}
        onClick={onSelect}
      >
        {Summary}
      </AccordionSummary>
      <AccordionDetails>{Details}</AccordionDetails>
    </Accordion>
  ) : (
    <Box padding='24px 40px'>
      {Summary && <Box paddingBottom='24px'>{Summary}</Box>}
      {Details}
    </Box>
  );
};
